import axios from '@/api/config';

const generatorRule = {
  getGeneratorRuleById(data) {
    return axios.get(`${process.env.BASE_URL}/generatorRule/getGeneratorRuleById/` + data, {});
  },
  getGeneratorRule(data) {
      return axios.get(`${process.env.BASE_URL}/generatorRule/getGeneratorRule`, {params: data});
    },
  pageList(data) {
    return axios.post(`${process.env.BASE_URL}/generatorRule/pageList`, data);
  },
  addGeneratorRule(data) {
    return axios.post(`${process.env.BASE_URL}/generatorRule/addGeneratorRule`, data);
  },
  updateGeneratorRule(data) {
    return axios.put(`${process.env.BASE_URL}/generatorRule/updateGeneratorRule`, data);
  },
  deleteGeneratorRule(data) {
    return axios.delete(`${process.env.BASE_URL}/generatorRule/deleteGeneratorRule`, {data: data});
  }
}

export default generatorRule;



// WEBPACK FOOTER //
// ./src/api/generatorRule.js